import React from "react"
import { BrowserRouter as Router, Route, Link } from "react-router-dom"
import { connect } from "react-redux"
import {
  Icon,
  FromToIcon,
  PlusIcon,
  CrownIcon,
  BriefcaseIcon,
  MarkerIcon,
  ForwardIcon,
  HomeIcon,
  DotIcon,
  BackIcon
} from "../../core/icons"

import {
  Checkbox,
  Radio,
  Input,
  Select,
  Switch,
  Button,
  DatePicker,
  Row,
  Col
} from "antd"
import Card, { TitleCard, CardHeader } from "../../core/Card"
import Line from "../../core/Line"
import { save, addCustom, toggle } from "./actions"
import "./BusinessLines.css"
import {
  reduxForm,
  hasSubmitSucceeded,
  hasSubmitFailed,
  Field,
  submit
} from "redux-form"
import makeField from "../makeField.js"
import WorkStatus from "./WorkStatus"

export const BusinessLine = ({ name, selected, toggle, children }) => (
  <Line className="DayRange">
    <Col xs={4} sm={2} onClick={() => toggle(name)}>
      <Icon
        type={name}
        defaultType="Work"
        selected={selected}
        width={30}
        height={30}
        {...selected && { color: "#31B59F" }}
      />
    </Col>
    <Col xs={18} sm={20} onClick={() => toggle(name)}>
      {children}
    </Col>
    <Col xs={1} sm={1}>
      <Checkbox
        className="checkbox-xlarge round"
        checked={selected}
        onChange={() => toggle(name)}
        disabled={!toggle}
      />
    </Col>
    <Col xs={1} sm={1} onClick={() => toggle(name)}>
      {/* spacer col */}
    </Col>
  </Line>
)

export const CustomLine = ({ name, selected, toggle, children }) => (
  <div className="Line CustomLine">
    <Row className="DayRange" type="flex" justify="start" align="middle">
      <Col xs={8} sm={2}>
        <Icon
          type={name}
          defaultType="Work"
          selected={selected}
          width={30}
          height={30}
          {...selected && { color: "#31B59F" }}
        />
      </Col>
      <Col xs={12} sm={22}>
        {children}
      </Col>
    </Row>
    <hr />
  </div>
)

const BusinessLines = ({
  error,
  customLine,
  active,
  available,
  toggle,
  dispatch,
  save,
  addCustom,
  showCustomField,
  submitting,
  onRemoteSubmit
}) => (
  <div className="BusinessLines">
    <TitleCard sticky>
      <h1>Business Lines</h1>
      <Button loading={submitting} onClick={onRemoteSubmit} type="primary">
        Save
      </Button>
    </TitleCard>

    <Card>
      <CardHeader title="What is your work status?" />
      <WorkStatus form="BusinessLines" />
    </Card>
    <Card>
      <CardHeader
        title="What do you do for work?"
        buttonOnClick={addCustom}
        buttonDisabled={showCustomField}
        buttonTitle="Add Custom"
        buttonIcon="plus"
      />

      {showCustomField && (
        <CustomLine selected name={"custom"}>
          <Button
            style={{ float: "right", marginTop: "2px", marginLeft: "12px" }}
            onClick={onRemoteSubmit}
            type="primary"
          >
            Add
          </Button>
          <Field
            name="customLine"
            type="text"
            component={"input"}
            placeholder="Enter business line / company name..."
          />
        </CustomLine>
      )}
      {error && <strong>{error}</strong>}

      {available.map((line, i) => (
        <BusinessLine
          key={i}
          name={line}
          selected={active.includes(line)}
          toggle={toggle}
        >
          {line}
        </BusinessLine>
      ))}
    </Card>
  </div>
)

const BusinessLinesForm = reduxForm({
  form: "BusinessLines",
  onSubmit: (data, dispatch, ownProps) => dispatch(save(data))
})(BusinessLines)

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onRemoteSubmit: () => dispatch(submit("BusinessLines")),
    addCustom: () => dispatch(addCustom()),
    toggle: name => dispatch(toggle(name))
  }
}

const onDemandTypes = [
  "Instacart",
  "Shipt",
  "Uber",
  "Lyft",
  "Doordash",
  "Airbnb",
  "Postmates",
  "Taskrabbit",
  "Favor",
  "Wonolo"
]

const getAvailableLines = businessLines =>
  !businessLines.persona.includes("Self-Employed")
    ? businessLines.available.filter(line => !onDemandTypes.includes(line))
    : businessLines.available

export default connect(
  ({ account: { businessLines } }) => ({
    ...businessLines,
    available: getAvailableLines(businessLines),
    initialValues: businessLines,
    enableReinitialize: true
  }),
  mapDispatchToProps
)(BusinessLinesForm)



// WEBPACK FOOTER //
// ./src/account/business-lines/BusinessLines.js